<template>
  <div class="notches" :key="`tab_content_6` + $store.state.calculatorData.calculatorPages[6].disabled">
    <div class="row">
      <div class="col-md-7">
        <h2>{{ $t(`notches.title`)}}</h2>
      </div>
      <div class="col-md-5 md-align-right" v-if="elementForm !== ''">
        <p>({{$t(`globals.currentSelectedForm`)}} <strong> {{$t(`elementForm.`+ elementForm +`.pdfTitle`)}}</strong>)</p>
      </div>
    </div>

    <b-button @click="explanationClick()" v-b-toggle.explanation-content-notches variant="primary" class="explanation"> <span v-html="$t(`globals.explanation`)"></span></b-button>
    <b-collapse id="explanation-content-notches" class="explanation-content">
      <b-card>
        <p v-html="$t(`notches.infoText`)"></p>
      </b-card>
    </b-collapse>
    <div v-if="isBox">
      <div class="d-none d-lg-block">
        <div class="radio-tile-group columns-2 ">
          <StoRadio step="notches" :type="`notch_`+elementForm" />
          <StoRadio step="notches" :type="`noNotch_`+elementForm" />
        </div>

        <div class="columns-2" v-if="(notches === 'notch') && (elementForm !== '')">
          <StoSlider name="f" tab="notches" />
        </div>
        <div class="columns-2" v-if="(notches === 'notch') && (elementForm !== '')">
          <StoSlider name="g" tab="notches" />
        </div>
      </div>

      <div class="d-lg-none">
        <div class="radio-tile-group columns-1 ">
          <StoRadio step="notches" :type="`notch_`+elementForm" />
        </div>
        <div class="columns-2" v-if="(notches === 'notch') && (elementForm !== '')">
          <StoSlider name="f" tab="notches" />
        </div>
        <div class="columns-2" v-if="(notches === 'notch') && (elementForm !== '')">
          <StoSlider name="g" tab="notches" />
        </div>
        <div class="radio-tile-group columns-1 ">
          <StoRadio step="notches" :type="`noNotch_`+elementForm" />
        </div>
      </div>
      <p class="variable"> <span v-html="$t(`variablesNice.w`)"></span> : {{w}} mm </p>
    </div>

    <div v-else>
      <div class="radio-tile-group columns-2">
        <StoRadio step="notches" :type="`notch_`+elementForm" :disabled="true" />
        <StoRadio step="notches" :type="`noNotch_`+elementForm" />
      </div>
    </div>

    <div class="info-wrapper">
      <p v-if="!isBox" class="info" v-html="$t('notches.triggerInfo1')"></p>
    </div>
    <StepNavi thisPage="7" :key="`navi_tab7_`+ $store.state.calculatorData.calculatorPages[7].disabled"/>
  </div>
</template>
<script>
import StoRadio from './StoRadio.vue'
import StoSlider from './StoSlider.vue'
import StepNavi from './StepNavi.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Notches',
  components: {
    StoRadio,
    StoSlider,
    StepNavi
  },
  computed: {
    ...mapGetters([
      'isBox',
      'notches',
      'elementForm',
      'w'
    ])
  },
  data () {
    return {
      textTriggerOpen: false
    }
  },
  methods: {
    explanationClick: function () {
      if (this.textTriggerOpen) {
        this.textTriggerOpen = false
      } else {
        this.$root.$children['0'].userDidAction = true
        this.textTriggerOpen = true
        let tabName = 'notches'
        let gtmEventLabel = this.$tc(tabName + '.virtualPageTitle')
        let virtualPageURL = '/' + this.$tc(tabName + '.virtualPageURL')
        let virtualPageTitle = this.$tc(tabName + '.virtualPageTitle')
        this.$root.$children['0'].globalGTMFkt('JKK-Events', 'Erläuterung', 'Button', gtmEventLabel, '', virtualPageURL, virtualPageTitle)
      }
    }
  },
  mounted: function () {
    // console.log('--- Notches rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.columns-2.slider{
  display: flex;
  margin-top: 1rem;
}
.columns-2.slider .input-container:nth-child(odd){
  margin: 0 0.5rem 0 0.4rem
}

.columns-2.slider .input-container:nth-child(even){
  margin: 0 0.4rem 0 0.5rem
}

</style>
